import request from '../../utils/request';
import type { AdminFeedbackResponse } from '@/types';

export interface AdminFeedbackParams {
  month?: string;
  platform?: string;
  search?: string;
}

/** Fetch admin feedback rows with optional filters. */
export function fetchAdminFeedback(params: AdminFeedbackParams): Promise<AdminFeedbackResponse> {
  return request.get('/api/analysis/abnormal-feedback', { params }).then((res) => res.data);
}
